import { CheckOccurrenceBody, CheckResponse } from "#/containers/Home/models";
import { request } from "#/utils/request";

export class CheckLegalApi {
  static async getCheckOccurrences(
    body: CheckOccurrenceBody
  ): Promise<CheckResponse> {
    const response = await (
      await request.post("occurrences", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    ).data;
    return response;
  }
}
